module.exports = __webpack_public_path__ + "img/thumb_aula23.0cb982df.jpg";